import type { Direction } from "../../../engine/direction";
import { directionDelta } from "../../../engine/direction";
import {
	colorConstant,
	hold,
	lerp,
	parabolic,
	randomAngle,
	randomBetween,
	stopAfter,
} from "../interpolation";
import { Particle } from "../particle";

const CONE_HALF_ANGLE = Math.PI / 4;
const MOTION_STOP = 0.4;

export class ConcreteDebrisParticle extends Particle {
	constructor(originX: number, originY: number, direction?: Direction) {
		let angle: number;
		if (direction) {
			const delta = directionDelta(direction);
			const baseAngle = Math.atan2(delta.y, delta.x);
			angle = baseAngle + randomBetween(-CONE_HALF_ANGLE, CONE_HALF_ANGLE);
		} else {
			angle = randomAngle();
		}

		const speed = randomBetween(0.8, 1.8);
		const startAngle = randomAngle();

		super(originX, originY, {
			ttl: randomBetween(800, 1200),
			position: stopAfter(parabolic(Math.cos(angle) * speed, Math.sin(angle) * speed, 7.0), MOTION_STOP),
			size: lerp(0.55, 0.35),
			opacity: hold(1.0, 0.75, lerp(1.0, 0.0)),
			color: colorConstant(55, 65, 75),
			rotation: stopAfter(lerp(startAngle, startAngle + randomBetween(2, 4)), MOTION_STOP),
		});
	}
}
